import { useLocalSearchParams } from 'expo-router'

import { PageScreen } from '@/src/features/page/ui/PageScreen'

export default function PageScreenWrapper() {
  const { slug } = useLocalSearchParams<{ slug: string }>()
  return <PageScreen slug={slug} />
}
